import { render, staticRenderFns } from "./riskTargetSafetyInfo.vue?vue&type=template&id=661d8221"
import script from "./riskTargetSafetyInfo.vue?vue&type=script&lang=js"
export * from "./riskTargetSafetyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661d8221')) {
      api.createRecord('661d8221', component.options)
    } else {
      api.reload('661d8221', component.options)
    }
    module.hot.accept("./riskTargetSafetyInfo.vue?vue&type=template&id=661d8221", function () {
      api.rerender('661d8221', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskTargetSafetyInfo.vue"
export default component.exports